import { pick } from "lodash";
import { EditAccountForm } from "PFModules/saas_admin/accounts/edit/edit_account.types";
import { Category } from "PFTypes/account";

export const parsePayload = (data: EditAccountForm) => ({
  ...pick(
    data,
    "owner",
    "customDomain",
    "fromEmailDomain",
    "feedbackEmailRecipient",
    "fullDomain",
    "name",
    "liveTtlInMinutes",
    "real",
    "senderName",
    "sessionTtlInMinutes",
    "theme"
  ),
  notificationSettings: pick(
    data.notificationSettings,
    "broadcastInvites",
    "digestEmail",
    "messagesStatus",
    "regularInvites",
    "roleInvites",
    "roleFilled",
    "ownerRoleFilled",
    "roleClosed",
    "interestExpressed",
    "interestsSummary",
    "marketplaceRoleClosed",
    "bookingApprovalRequests",
    "feedbackRequest",
    "roleChanged"
  ),
  brandCategories: buildCategories(data.brandCategories),
  languageCategories: buildCategories(data.languageCategories),
  qualificationCategories: buildCategories(data.qualificationCategories),
  skillCategories: buildCategories(data.skillCategories)
});

const buildCategories = (categories: Category[] | undefined) =>
  (categories ?? []).map((category) => ({
    value: category.text || category.value,
    global_id: category.global_id
  }));
